import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    nombre: '',
    password: '',
    confirmedPassword: '',
    rowVersion: null,
};

const mutations = {
    updateField,

    'INICIALIZAR_USUARIO_PWA'(state) {
        state.nombre = '';
        state.password = '';
        state.confirmedPassword = '';
        state.rowVersion = null;
    },
    'SET_USUARIO_PWA'(state, usuario) {
        state.nombre = usuario.username;
        state.rowVersion = usuario.rowVersion;
    },
};

const getters = {
    getField,
};

const actions = {
    getUsuario ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_USUARIO_PWA');

            apiAxios.get('usuariospwa') 
                .then(res => {
                    commit('SET_USUARIO_PWA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    updatePassword ( { state } ) {
        return new Promise((resolve, reject) => {
            let pass= {
                password: state.password,
                rowVersion: state.rowVersion
            }
            
            let url = 'usuariospwa/pass';
            apiAxios.post(url, pass)
                .then(response => resolve(response))
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    desbloquear ( {} ) {
        return new Promise((resolve, reject) => {
            let url = 'usuariospwa/desbloquear';
            apiAxios.post(url)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}